


function Display(props){
    return <div id="display"><span>{props.disp}</span></div>
}

export default Display;